import { baseApi } from '@/shared/api/baseApi';
import type { AiConversationDto, AiMessageDto, SendAiMessageResult } from '../model/types';

const aiChatApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listAiConversations: builder.query<AiConversationDto[], void>({
      query: () => 'ai/conversations',
      providesTags: ['AiConversation'],
    }),
    createAiConversation: builder.mutation<AiConversationDto, void>({
      query: () => ({ url: 'ai/conversations', method: 'POST' }),
      invalidatesTags: ['AiConversation'],
    }),
    getAiMessages: builder.query<AiMessageDto[], string>({
      query: (conversationId) => `ai/conversations/${conversationId}/messages`,
      providesTags: (_result, _error, conversationId) => [{ type: 'AiConversation', id: conversationId }],
    }),
    sendAiMessage: builder.mutation<SendAiMessageResult, { conversationId: string; text: string }>({
      query: ({ conversationId, text }) => ({ url: `ai/conversations/${conversationId}/messages`, method: 'POST', body: { text } }),
      // Инвалидирует и сами сообщения беседы, и список бесед — у первого сообщения появляется
      // заголовок, а бэкенд бампает updatedAt беседы при каждом сообщении (чат поднимается в списке).
      invalidatesTags: (_result, _error, { conversationId }) => [{ type: 'AiConversation', id: conversationId }, 'AiConversation'],
    }),
    deleteAiConversation: builder.mutation<void, string>({
      query: (conversationId) => ({ url: `ai/conversations/${conversationId}`, method: 'DELETE' }),
      invalidatesTags: ['AiConversation'],
    }),
  }),
});

export const {
  useListAiConversationsQuery,
  useCreateAiConversationMutation,
  useGetAiMessagesQuery,
  useSendAiMessageMutation,
  useDeleteAiConversationMutation,
} = aiChatApi;

export { aiChatApi };
